import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import ExcludedUsers from "../views/ExcludedUsers";
import Dashboard from '../views/Dashboard.vue';
import DashboardCharts from '../views/DashboardCharts.vue';
import Transactions from '../views/Transactions.vue';
import TransactionsAdvanced from '../views/TransactionsAdvanced.vue';
import GGR from '../views/GGR.vue';
import AuthReport from '../views/AuthReport.vue';
import ConversionReport from '../views/ConversionReport.vue';
import Players from '../views/Players.vue';
import Countries from '../views/Countries.vue';
import ExportTasks from '../views/ExportTasks.vue';
import Sessions from '../views/Sessions.vue';
import GameActions from '../views/GameActions.vue';
import GameAnalytic from '../views/GameAnalytic.vue';
import GameFinancialMetrics from '../views/GameFinancialMetrics.vue';
import {ROLE_ADMIN, ROLE_OPERATOR, ROLE_REPORTS} from "../definitions/roles";
import AdvancedReports from "@/views/AdvancedReports.vue";
import Digitain from "@/views/Digitain.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN, ROLE_REPORTS, ROLE_OPERATOR],
            groupName: 'management',
        },
    },
    {
        path: '/export',
        name: 'export',
        component: ExportTasks,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN, ROLE_REPORTS, ROLE_OPERATOR],
            groupName: 'management',
        },
    },
    {
        path: '/dashboard/charts/',
        name: 'dashboard.charts',
        component: DashboardCharts,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN, ROLE_REPORTS, ROLE_OPERATOR],
            groupName: 'management',
        },
    },
    {
        path: '/transactions',
        name: 'transactions',
        component: Transactions,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN, ROLE_REPORTS, ROLE_OPERATOR],
            groupName: 'management',
        },
    },
    {
        path: '/transactions-advanced',
        name: 'transactionsAdvanced',
        component: TransactionsAdvanced,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN, ROLE_OPERATOR],
            groupName: 'management',
        },
    },
    {
        path: '/ggr',
        name: 'ggr',
        component: GGR,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN, ROLE_REPORTS, ROLE_OPERATOR],
            groupName: 'management',
        },
    },
    {
        path: '/auth-report',
        name: 'authReport',
        component: AuthReport,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN, ROLE_REPORTS, ROLE_OPERATOR],
            groupName: 'management',
        },
    },
    {
        path: '/conversion-report',
        name: 'conversionReport',
        component: ConversionReport,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN],
            groupName: 'management',
        },
    },
    {
        path: '/players',
        name: 'players',
        component: Players,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN],
            groupName: 'management',
        },
    },
    {
        path: '/countries',
        name: 'countries',
        component: Countries,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN],
            groupName: 'management',
        },
    },
    {
        path: '/sessions/:sessionKey/game-actions',
        name: 'sessionGameActions',
        component: GameActions,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN, ROLE_REPORTS, ROLE_OPERATOR],
            groupName: 'management',
        },
    },
    {
        path: '/game-actions',
        name: 'gameActions',
        component: GameActions,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN],
            groupName: 'management',
        },
    },
    {
        path: '/game-analytic',
        name: 'gameAnalytic',
        component: GameAnalytic,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN],
            groupName: 'management',
        },
    },
    {
        path: '/game-financial-metrics',
        name: 'gameFinancialMetrics',
        component: GameFinancialMetrics,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN],
            groupName: 'management',
        },
    },
    {
        path: '/sessions',
        name: 'sessions',
        component: Sessions,
        meta: {
            requiresAuth: true,
            roles: [ROLE_ADMIN, ROLE_REPORTS, ROLE_OPERATOR],
            groupName: 'management',
        },
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/excluded-users',
        name: 'excludedUsers',
        component: ExcludedUsers,
        meta: {
            roles: [ROLE_ADMIN],
            requiresAuth: true,
            groupName: 'management',
        },
    },
    {
        path: '/advanced-reports/main',
        name: 'advanced-reports-main',
        component: AdvancedReports,
        meta: {
            roles: [ROLE_ADMIN],
            requiresAuth: true,
            groupName: 'management',
        },
    },
    {
        path: '/advanced-reports/digitain',
        name: 'digitain',
        component: Digitain,
        meta: {
            roles: [ROLE_ADMIN],
            requiresAuth: true,
            groupName: 'management',
        },
    },
    {
        path: '*',
        redirect: '/',
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
